module.exports = __webpack_public_path__ + "assets/img/630200.615300c2.png";